export const POST_MESSAGE = "POST_MESSAGE";
export const FETCH_ALL_MESSAGES = "FETCH_ALL_MESSAGES";